import React, { useState } from "react";
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import axios from "axios";
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';
import CircularProgress from '@mui/material/CircularProgress';
import { Link, useNavigate } from 'react-router-dom';

function Login() {

  let emailErrorState = false;
  let passwordErrorState = false;
  let emailErrorMessage = "";
  let passwordErrorMessage = "";

  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [accountRelatedErrorMessage, setAccountRelatedErrorMessage] = useState("");
  const [isFormSubmitButtonClicked, setIsFormSubmitButtonClicked] = useState(false);
  

  const navigate = useNavigate();
  const [inputValue, setInputValue] = useState({
    email: "",
    password: "",
  });
  const { email, password } = inputValue;

  // Input field error handler start

  if(isFormSubmitButtonClicked) {

    let emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    let passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=!])(?=.*[a-zA-Z0-9@#$%^&+=!]).{8,}$/;

    if (!email) {
      emailErrorState = true;
      emailErrorMessage = "Please enter the email!";
    } else if (!email.match(emailPattern)) {
      emailErrorState = true;
      emailErrorMessage = "Please enter the valid email!";
    } else {
      emailErrorState = false;
      emailErrorMessage = "";
    }

    if (!password) {
      passwordErrorState = true;
      passwordErrorMessage = "Please enter the password!";
    } else if (!password.match(passwordPattern)) {
      passwordErrorState = true;
      passwordErrorMessage = "Password is not valid!, Please ensure it has at least 8 characters, including at least one lowercase letter, one uppercase letter, one digit, and one special character.";
    } else {
      passwordErrorState = false;
      passwordErrorMessage = "";
    }

  }

  // Input field error handler end

  // Input field value handler start

  const handleOnChange = (e) => {
    setAccountRelatedErrorMessage("");
    const { name, value } = e.target;
    setInputValue({
      ...inputValue,
      [name]: value,
    });
  };

  // Input field value handler end  

  // Login submit func start

  const handleSubmit = async (e) => {

    setIsFormSubmitButtonClicked(true);
    e.preventDefault();

    if(emailErrorState == false && passwordErrorState == false) {

      setIsFormSubmitted(true);

      try {
        const { data } = await axios.post(
          "https://salesforceb2b.customers.bigfivecrm.com/login",
          {
            ...inputValue,
          },
          { withCredentials: true }
        );
        
        const { success, message, isLoggedIn } = data;
        sessionStorage.setItem("userName", data.user_name);
        document.cookie = `isLoggedIn=${isLoggedIn}; path=/`;
        if(isLoggedIn) {
          sessionStorage.setItem("fdasdfaRETRFDGFDH234%82ERXB23!45sgf", "fsfkDG73DGFDGE&^FDHd!@fJHG2334T");
          setIsFormSubmitted(false);
        } else {
          sessionStorage.setItem("fdasdfaRETRFDGFDH234%82ERXB23!45sgf", "DSFSDhew234%*dgffd126DR3$%sDFGF");
          setAccountRelatedErrorMessage(message);
          setIsFormSubmitted(false);
        }
        if (success) {
          setTimeout(() => {
            navigate("/Dashboard");
          }, 100);
        }
      } catch (error) {
        console.log(error);
      }

    }

  };

  // Login submit func end


  return (
    <>
      <Container component="main" maxWidth="xs" sx={{ marginTop: 12 }}>
      <CssBaseline />
      <Card>
        <CardContent>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              SIGN IN
            </Typography>
            <Box component="form" noValidate sx={{ mt: 1 }}>
              <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="Email Address"
                name="email"
                error={emailErrorState}
                helperText={emailErrorMessage}
                autoComplete="email"
                value={email}
                variant="standard"
                autoFocus
                onChange={handleOnChange}
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                value={password}
                id="password"
                variant="standard"
                error={passwordErrorState}
                helperText={passwordErrorMessage}
                autoComplete="current-password"
                onChange={handleOnChange}
              />

              { accountRelatedErrorMessage == "" ? "" : <Stack sx={{ width: '100%' }} spacing={2}>
                <Alert severity="error">{accountRelatedErrorMessage}</Alert>
              </Stack> }
              
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
                onClick={handleSubmit}
              >
                { isFormSubmitted ? <CircularProgress style={{ color: "white", height: "24px", width: "24px" }} /> : "Submit" }
              </Button>
              
            </Box>
          </Box>
        </CardContent>
      </Card>
    </Container>    
    </>
  )
}

export default Login;

